export interface Country {
  name: string;
  code: string;
}

export type CountriesType = Country[];

export const Countries: CountriesType = [
  { name: 'Germany', code: 'DE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'France', code: 'FR' },
  { name: 'Austria', code: 'AT' },
  { name: 'Luxemburg', code: 'LU' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Italy', code: 'IT' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Poland', code: 'PL' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Great Britain', code: 'GB' },
  { name: 'Spain', code: 'ES' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Bosnia-Herzegovina', code: 'BA' },
  { name: 'Romania', code: 'RO' },
  { name: 'Norway', code: 'NO' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'Russia', code: 'RU' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Albania', code: 'AL' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'Armenia', code: 'AM' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Brazil', code: 'BR' },
  { name: 'China', code: 'CN' },
  { name: 'Egypt', code: 'EG' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Finland', code: 'FI' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Greece', code: 'GR' },
  { name: 'India', code: 'IN' },
  { name: 'Israel', code: 'IL' },
  { name: 'Japan', code: 'JP' },
  { name: 'Korea', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Malta', code: 'MT' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Macedonia', code: 'MK' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Oman', code: 'OM' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Kosovo', code: 'XK' },
  { name: 'Turkey', code: 'TR' },
  { name: 'USA', code: 'US' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Taiwan', code: 'TW' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Australia', code: 'AU' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Canada', code: 'CA' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Chile', code: 'CL' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Panama', code: 'PA' },
  { name: 'Peru', code: 'PE' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Vietnam', code: 'VN' },
];

export interface AutocompleteCountry {
  title: string;
  subtitle?: string;
}

export type CountriesAutocomplete = AutocompleteCountry[];

export const CountriesOptions: CountriesAutocomplete = Countries.map(c => ({
  title: c.name,
  subtitle: c.code,
}));
